var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.03 41.7c-.82 0-1.522-.29-2.105-.869s-.875-1.275-.875-2.088c0-.782.288-1.476.865-2.083.577-.607 1.27-.91 2.08-.91.837 0 1.538.304 2.105.911s.85 1.307.85 2.1c0 .793-.282 1.481-.845 2.064s-1.255.875-2.075.875Zm0-14.75c-.82 0-1.522-.288-2.105-.865s-.875-1.27-.875-2.08c0-.837.288-1.538.865-2.105s1.27-.85 2.08-.85c.837 0 1.538.282 2.105.845s.85 1.254.85 2.075c0 .82-.282 1.522-.845 2.105s-1.255.875-2.075.875Zm0-14.7c-.82 0-1.522-.295-2.105-.884s-.875-1.297-.875-2.125c0-.827.288-1.533.865-2.116.577-.583 1.27-.875 2.08-.875.837 0 1.538.294 2.105.882.567.588.85 1.296.85 2.123 0 .828-.282 1.534-.845 2.118-.563.585-1.255.877-2.075.877Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.c66dff1a5cb768099a9103887a14ffd3.svg";
export { ForwardRef as ReactComponent };